<script setup lang="ts">
import { computed } from 'vue'
import type { Tone } from '../tokens'
import { toneVars } from '../tone-vars'

/**
 * 空态。
 *
 * 为什么单独立一个组件:裸写「没有数据」四个字的页面,和「加载失败」的页面
 * 长得一模一样。空态至少要说清两件事 —— 这里本来该有什么(主文案)、
 * 以及为什么没有(hint)。hint 是可选的,但主文案必填。
 */
const props = withDefaults(defineProps<{ text: string; hint?: string; tone?: Tone }>(), {
  tone: 'light',
})

const vars = computed(() => toneVars(props.tone))
</script>

<template>
  <div class="empty" :style="vars">
    <svg
      class="art"
      width="40"
      height="40"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <!-- 一个敞口的空箱:盖子掀开、里面什么都没有 -->
      <path d="M8 19 24 11l16 8-16 8z" />
      <path d="M8 19v14l16 8 16-8V19" />
      <path d="M24 27v14" />
    </svg>
    <p class="text">{{ props.text }}</p>
    <p v-if="props.hint" class="hint">{{ props.hint }}</p>
  </div>
</template>

<style scoped>
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 32px 16px;
  text-align: center;
}

.art {
  color: var(--sd-text3);
  opacity: 0.55;
  margin-bottom: 4px;
}

.text {
  margin: 0;
  font-size: 13px;
  color: var(--sd-text2);
}

.hint {
  margin: 0;
  font-size: 12px;
  color: var(--sd-text3);
  max-width: 420px;
  line-height: 1.6;
}
</style>
